<template>
  <el-dialog
    title="绑定场次"
    :visible.sync="showDialog"
    :append-to-body="true"
    width="60%"
  >
    <el-table
      ref="playsTable"
      :data="playList"
      tooltip-effect="dark"
      style="width: 100%"
      @selection-change="handleSelectionChange">
      <el-table-column
        type="selection"
        width="55">
      </el-table-column>
      <el-table-column
        prop="play_name"
        label="场次名称">
      </el-table-column>
      <el-table-column
        prop="play_time"
        label="场次时间">
      </el-table-column>
      <el-table-column
        prop="meeting_point"
        label="汇合点">
      </el-table-column>
      <el-table-column
        prop="guide_user_name"
        label="默认讲师">
      </el-table-column>
      <el-table-column
        prop="status_name"
        label="场次状态">
        <template slot-scope="scope">
          <el-tag size="mini" type="success" v-if="(scope.row.status & 1)===1">{{ scope.row.status_name }}
          </el-tag>
          <el-tag size="mini" type="danger" v-else>{{ scope.row.status_name }}</el-tag>
        </template>
      </el-table-column>
    </el-table>
    <div style="text-align: right;margin-top: 20px;">
      <el-button size="small" type="primary" @click="postBindPlay" :loading="postLoading">确认选中</el-button>
      <el-button size="small" @click="showDialog = false">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "i-bind-play",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    productId: {
      type: String | Number,
      default: ''
    },
  },
  data: function () {
    return {
      showDialog: false,
      playList:[],
      selectedPlays:"",
      postLoading:false,
    }
  },
  methods:{
    getPlayList:function (){
      this.$http.request('bindPlayList',{pid:this.productId}).then(res=>{
        this.playList = res.data;
        this.playList.forEach(row=>{
          if(row.has_bind === true){
            this.$nextTick(() => {
              this.$refs.playsTable.toggleRowSelection(row)
            });

          }
        })
      })
    },
    handleSelectionChange:function (value){
      let playIds = [];
      value.forEach(play=>{
        playIds.push(play.play_id);
      })
      this.selectedPlays = playIds;
    },
    postBindPlay:function (){
      this.postLoading = true;
      this.$http.request('bindPlays',{pid:this.productId,play_ids: this.selectedPlays}).then(res=>{
        this.postLoading = false;
        if(res.status === 'success'){
          this.$message({
            message: res.message,
            type: 'success',
          });
        }
      })
    }
  },
  watch: {
    show: function () {
      this.showDialog = this.show;
      if(this.showDialog === true){
        this.getPlayList();
      }
    },
    showDialog: function () {
      this.$emit('change', this.showDialog);
    },
    productId: function () {
      this.getPlayList();
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/i-bind-play.vue